import React, { useEffect, useState, Fragment } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DeleteIcon from '@material-ui/icons/Delete';
import Slide from '@material-ui/core/Slide';
import {connect} from 'react-redux';
import { Typography } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: (props) => (props.align == 'right') ? 'flex-end' : 'center'
  },
  root: {

  },
  paper: {
    margin: '0px',
    height: (props) => props.height,
    width: (props) => props.width,
    maxWidth: (props) => props.maxWidth
  },
  draggableIcon: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: theme.shadows[3],
  },
}));


function AlertDialogSlide(props) {
  const classes = useStyles(props);
  const [position, setPosition]=useState({bottom:150, right:50});
  const [confirm_open_draft, setConfirmOpenDraft]=useState(false);


  useEffect(()=>{
    if(props.drafts[props.company_id]!=undefined && props.drafts[props.company_id][props.draft_type]!=undefined){
      if (props.initial_values != undefined && ((props.initial_values.id != undefined && props.initial_values.id != props.drafts[props.company_id][props.draft_type].id) || props.initial_values.draft==true)){
        props.deleteDraft({ company_id: props.company_id, draft_type: props.draft_type });
      }else{
        setConfirmOpenDraft(true);
    }}
  },[]);


  return (
    <Dialog
      open={true}
      classes={{ container: classes.container, root: classes.root, paper: classes.paper }}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => { 
        if (props.form_props.current != undefined) { props.createUpdateDraft({ draft_type: props.draft_type, company_id: props.company_id, draft_id: props.draft_type, draft_data: { ...props.form_props.current.values, draft_props:(props.draft_props==undefined)?undefined:props.draft_props.current, draft:true}});}
          props.handleClose() 
      }}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title" style={{ position: 'relative', marginTop: (props.top_space == true) ? '10px' : undefined }}>
        {(props.icon != undefined) ? <span style={{ width: '70px', position: 'relative' }}><div style={{ position: 'absolute', top: '-2px' }}>{props.icon}</div></span> : null}<span style={{ marginLeft: '50px' }}>{props.title}</span>
        {(props.handleDelete == undefined) ? null : <DeleteIcon color='error' onClick={() => { props.handleDelete(); }} style={{ cursor: 'pointer', position: 'absolute', top: '15px', right: '20px' }} />}
      </DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth:'600px', minHeight:'200px'}}>
          {(confirm_open_draft==true)?<Typography>Do you wish to continue with your current draft?</Typography>:props.content}
        </div>
      </DialogContent>
      <DialogActions>
      {(confirm_open_draft==true)?
        <Fragment>
            <Button onClick={() => {
              console.log('OPEN DRAFT', JSON.parse(JSON.stringify(props.drafts[props.company_id][props.draft_type])));
              props.openDraft(JSON.parse(JSON.stringify(props.drafts[props.company_id][props.draft_type]))); 
              if(props.setDraftDefaults!=undefined){props.setDraftDefaults(props.drafts[props.company_id][props.draft_type].draft_props);}
              props.deleteDraft({ company_id: props.company_id, draft_type: props.draft_type });
              setConfirmOpenDraft(false);
              }} color="secondary">
              {"Yes"}
            </Button>
            <Button onClick={()=>{props.deleteDraft({company_id:props.company_id, draft_type:props.draft_type}); setConfirmOpenDraft(false);}} color="primary">
              {"No"}
            </Button>
        </Fragment>
        :
        <Fragment>
        {(props.secondary_button_text==undefined)?null:
            <Button type={(props.submit_button == true) ? 'submit' : undefined} type='submit' onClick={(e) => { if (props.secondary_accept_button_click != undefined) { props.secondary_accept_button_click(); } }} color="primary">
              {props.secondary_button_text}
            </Button>
        }
        <Button type={(props.submit_button == true) ? 'submit' : undefined} type='submit' onClick={(e) => { if (props.accept_button_click != undefined) { props.accept_button_click(); } }} color="primary">
          {(props.button_text == undefined) ? 'Save' : props.button_text}
        </Button>
        </Fragment>
      }
      </DialogActions>
    </Dialog>
  );
}


export default connect(ss, dd)(AlertDialogSlide);

function ss(state){
  return{
    drafts:state.operational_states.drafts.companies
  }
}

function dd(dispatch){
  return{
    createUpdateDraft:(val)=>{console.log('STATE CREATE UPDATE DRAFTS', val); dispatch({type:'STATE_CREATE_UPDATE_DRAFTS', val:val});},
    deleteDraft: (val) => { dispatch({ type:'STATE_DELETE_DRAFTS', val:val})}
  }
}


//<Card
//  key={1}
//  index={1}
//  id={1}
//  moveCard={(it) => { console.log('IMPORTANT', it); }}
//  onDrop={
//    (item, index, monitor) => {
//      console.log(item, index, monitor, 'IMPORTANT');
//
//      //const delta = monitor.getDifferenceFromInitialOffset(); // How much the mouse moved
//      //if (delta) {
//      //  const newX = position.x + delta.x;
//      //  const newY = position.y + delta.y;
//      //  setPosition({ x: newX, y: newY }); // Update position
//      //}
//    }}
//  text={
//    <Paper elevation={24} style={{ zIndex: 2147483647, boxShadow: '0px 3px 5px - 1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)', position: 'fixed', width: props.width, height: props.height, maxWidth: props.maxWidth, top: '50%', left: '50%', transform: 'translate(-50%, -50%)', padding: '16px' }}>
